/** @jsxImportSource @emotion/react */

import { ReactComponent as EmptyIcon } from "assets/desktop/icons/empty.svg";

import { EmptyComponentStyle } from "./index.style";

const EmptyComponent = () => {
  
  return (
    <div css={EmptyComponentStyle.self}>
      <EmptyIcon css={EmptyComponentStyle.emptyIcon} />
      <p css={EmptyComponentStyle.emptyMsg}>{"沒有資料"}</p>
    </div>
  );
};

export default EmptyComponent;
